<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Parameter Name</th>
              <th>Min</th>
              <th>Max</th>
              <th>Unit</th>
              <th>Measurement Point</th>
              <th>Threshold</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.parameter_setup_details.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(parameter_detail, sr) in form.parameter_setup_details"
              :key="`parameter_detail${sr}`"
            >
              <td>{{ sr + 1 }}.</td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Parameter Name"
                  v-model="parameter_detail.parameter_name"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Min"
                  v-model="parameter_detail.min"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Max"
                  v-model="parameter_detail.max"
                />
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="parameter_detail.unit_id"
                  :suggestions="units"
                  placeholder="Select Units"
                ></my-select>
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Measurement Point"
                  v-model="parameter_detail.measurement_point"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Threashold"
                  v-model="parameter_detail.threshold"
                />
              </td>
              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteParameterSetupDetail(parameter_detail)"
                    v-if="!parameter_detail.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="delete_parameter_detail_data(parameter_detail.id)"
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.parameter_setup_details">
              <td
                colspan="14"
                align="center"
                @click="addEmptyParameterSetupDetails()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "ParameterSetupDetailFormWidget",
  props: ["form"],
  data() {
    return {
      units: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("parameter_setups/masters");
      masters = masters.data;
      masters.units.forEach((unit) => {
        this.units.push({
          id: unit.id,
          name: unit.unit_name,
        });
      });
    },
    deleteParameterSetupDetail(detail) {
      this.form.parameter_setup_details =
        this.form.parameter_setup_details.filter((ar) => ar != detail);
    },
    addEmptyParameterSetupDetails() {
      this.form.parameter_setup_details.push({
        company_id: this.company.id,
        parameter_name: "",
        max: "",
        min: "",
        unit_id: "",
        measurement_point: "",
        threshold: "",
      });
    },
    async delete_parameter_detail_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=parameter_setup_details`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
